<template>
  <div class="page-column">
    <MatchHeader/>
    <MatchInfo />
    <MatchMenu />
    <MatchNoticeDetail />
    <Footer/>
  </div>
</template>

<script>
import MatchHeader from '../layout/MatchHeader.vue'
import MatchInfo from '@comm/components/MatchInfo.vue'
import MatchMenu from '@comm/components/MatchMenu.vue'
import MatchNoticeDetail from '@comm/components/MatchNoticeDetail.vue'
import Footer from '../layout/Footer.vue'
export default {
  components: {
    MatchHeader,
    MatchInfo,
    MatchMenu,
    MatchNoticeDetail,
    Footer
  },
  data () {
    return {
    }
  },
  created () {
    window.scrollTo(0, 0)
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.page-column {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/match/NoticeDetail.vue